function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module widget/widgetresize/sizeview
 */
import View from '@ckeditor/ckeditor5-ui/src/view';
/**
 * A view displaying the proposed new element size during the resizing.
 *
 * @protected
 * @extends {module:ui/view~View}
 */

var SizeView = /*#__PURE__*/function (_View) {
  _inherits(SizeView, _View);

  var _super = _createSuper(SizeView);

  function SizeView() {
    var _this;

    _classCallCheck(this, SizeView);

    _this = _super.call(this);
    /**
     * The visibility of the view defined based on the existence of the host proposed dimensions.
     *
     * @private
     * @observable
     * @readonly
     * @member {Boolean} #_isVisible
     */

    /**
     * The text that will be displayed in the `SizeView` child.
     * It can be formatted as the pixel values (e.g. 10x20) or the percentage value (e.g. 10%).
     *
     * @private
     * @observable
     * @readonly
     * @member {Boolean} #_label
     */

    /**
     * The position of the view defined based on the host size and active handle position.
     *
     * @private
     * @observable
     * @readonly
     * @member {String} #_viewPosition
     */

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-size-view', bind.to('_viewPosition', function (value) {
          return value ? "ck-orientation-".concat(value) : '';
        })],
        style: {
          display: bind.if('_isVisible', 'none', function (visible) {
            return !visible;
          })
        }
      },
      children: [{
        text: bind.to('_label')
      }]
    });

    return _this;
  }
  /**
   * A method used for binding the `SizeView` instance properties to the `ResizeState` instance observable properties.
   *
   * @protected
   * @param {module:widget/widgetresize~ResizerOptions} options
   * An object defining the resizer options, used for setting the proper size label.
   * @param {module:widget/widgetresize/resizerstate~ResizeState} resizeState
   * The `ResizeState` class instance, used for keeping the `SizeView` state up to date.
   */


  _createClass(SizeView, [{
    key: "_bindToState",
    value: function _bindToState(options, resizeState) {
      this.bind('_isVisible').to(resizeState, 'proposedWidth', resizeState, 'proposedHeight', function (width, height) {
        return width !== null && height !== null;
      });
      this.bind('_label').to(resizeState, 'proposedHandleHostWidth', resizeState, 'proposedHandleHostHeight', resizeState, 'proposedWidthPercents', function (width, height, widthPercents) {
        if (options.unit === 'px') {
          return "".concat(width, "\xD7").concat(height);
        } else {
          return "".concat(widthPercents, "%");
        }
      });
      this.bind('_viewPosition').to(resizeState, 'activeHandlePosition', resizeState, 'proposedHandleHostWidth', resizeState, 'proposedHandleHostHeight', // If the widget is too small to contain the size label, display the label above.
      function (position, width, height) {
        return width < 50 || height < 50 ? 'above-center' : position;
      });
    }
    /**
     * A method used for cleaning up. It removes the bindings and hides the view.
     *
     * @protected
     */

  }, {
    key: "_dismiss",
    value: function _dismiss() {
      this.unbind();
      this._isVisible = false;
    }
  }]);

  return SizeView;
}(View);

export { SizeView as default };